/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerplacement1Inputs */

const en_flyerplacement1 = /** @type {(inputs: Flyerplacement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR placement`)
};

const de_flyerplacement1 = /** @type {(inputs: Flyerplacement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Platzierung`)
};

/**
* | output |
* | --- |
* | "QR placement" |
*
* @param {Flyerplacement1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerplacement1 = /** @type {((inputs?: Flyerplacement1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerplacement1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerplacement1(inputs)
	return de_flyerplacement1(inputs)
});
export { flyerplacement1 as "flyerPlacement" }